import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { LayoutDashboard, Calculator, Wrench, Briefcase, Rocket } from "lucide-react";

/**
 * v3.7 — Elite Light mobile bottom nav. Warm cream glassmorphism.
 * No more dark navy (#162347) — fixed light theme everywhere.
 */
export default function BottomNav() {
  const { t } = useLanguage();
  const location = useLocation();
  const links = [
    { path: "/", label: t("nav.dashboard"), icon: LayoutDashboard },
    { path: "/tools", label: t("nav.tools"), icon: Wrench },
    { path: "/crm", label: "CRM", icon: Briefcase },
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/" || location.pathname.startsWith("/series");
    if (path === "/tools") return location.pathname.startsWith("/tools") || location.pathname.startsWith("/calculators") || location.pathname.startsWith("/crm/leadgen") || location.pathname.startsWith("/crm/referrals");
    if (path === "/crm") return location.pathname.startsWith("/crm") && !location.pathname.startsWith("/crm/leadgen") && !location.pathname.startsWith("/crm/referrals");
    return location.pathname === path;
  };

  return (
    <nav
      className="ink-board fixed bottom-0 left-0 right-0 z-50 lg:hidden"
      style={{
        background: "color-mix(in srgb, var(--bg) 92%, transparent)",
        backdropFilter: "blur(20px) saturate(140%)",
        WebkitBackdropFilter: "blur(20px) saturate(140%)",
        borderTop: "1px solid var(--line)",
        boxShadow: "0 -1px 0 rgba(255,255,255,0.5) inset, 0 -4px 18px rgba(38,34,26,0.05)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16">
        {links.map(l => {
          const Icon = l.icon;
          const active = isActive(l.path);
          const color = active ? "var(--accent)" : "var(--muted)";
          return (
            <Link
              key={l.path}
              to={l.path}
              data-testid={`bottom-nav-${l.path.replace("/", "") || "dashboard"}`}
              className="flex flex-col items-center justify-center gap-1 flex-1 py-2 min-h-[44px]"
            >
              {/* Lime: aktivní = černá ikona na neonové pilulce s černým obrysem 1 px (černá vs šedá by byla
                  jen odstín). Pilulka je stín, ne padding — rozložení se nehne; ostatní motivy fill nemají → průhledná. */}
              <Icon size={21} strokeWidth={1.5} style={active
                ? { color, background: "var(--accent-fill, transparent)", borderRadius: 999, boxShadow: "-7px 0 0 4px var(--accent-fill, transparent), 7px 0 0 4px var(--accent-fill, transparent), 0 0 0 4px var(--accent-fill, transparent), -7px 0 0 5px var(--accent-fill-edge, transparent), 7px 0 0 5px var(--accent-fill-edge, transparent), 0 0 0 5px var(--accent-fill-edge, transparent)" }
                : { color }} />
              <span className="text-[11px] font-medium" style={{ color, fontWeight: active ? 600 : 500 }}>
                {l.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
